<ng-container *ngFor="let league of topLeaguesData">
  <div class="item" (click)="getMatch(league)">
    <div class="left">
      <div class="league">
        <image-loader-utils [url]="league.IsoName" [isFlags]="true" extraClasses="flag-rounded mt"></image-loader-utils>
      </div>
    </div>
    <div class="mid">{{ league.TournamentName }}</div>
    <div class="right">{{ league.TournamentSportEventCount }}</div>
  </div>
</ng-container>

<ng-container *ngIf="topLeaguesData == undefined || topLeaguesData?.length < 1">
  <ngx-skeleton-loader [theme]="{ height: '19px', width: '230px', background: 'var(--white-color-300)' }" count="10"></ngx-skeleton-loader>
</ng-container>
